import { useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { CrossBoldIcon } from '@capsicum/common-web/icons';
import {
	RECEIVE_NETWORK_LABELS,
	RECEIVE_NETWORK_SHORTCODES,
	type ReceiveNetworks,
	useNativeCurrencyNetwork
} from '@capsicum/features/wallet/shared';
import { useState } from 'react';

import { AddressCopyCard } from '../../ui';

import { S } from './address.styled';

export const AddressFantokens = () => {
	const { $t } = useIntl();
	const [showSnack, setShowSnack] = useState(false);
	const { searchParams } = useRouter();

	const title = $t('wallet.receive.address.titleFantokens');
	const clipboard = $t('wallet.receive.address.clipboard');

	const network = searchParams?.get('network') || '';

	const { data: networkData, isLoading } = useNativeCurrencyNetwork(network);

	const networkItem = {
		address: networkData?.blockchainAddress,
		label: RECEIVE_NETWORK_LABELS[network as ReceiveNetworks],
		shortCode: RECEIVE_NETWORK_SHORTCODES[network as ReceiveNetworks]
	};

	return (
		<S.Container>
			<S.Title>{title}</S.Title>
			<AddressCopyCard isLoading={isLoading} network={networkItem} showSnack={setShowSnack} />
			{showSnack && (
				<S.StyledSnackbar
					actionText=""
					description={clipboard}
					rightIcon={CrossBoldIcon}
					testID="receiveFT-address-snackbar"
					onActionActivate={() => null}
					onActivate={() => setShowSnack(false)}
					onRightIconActivate={() => setShowSnack(false)}
				/>
			)}
		</S.Container>
	);
};
